'use strict';

var toSources = require('./to-sources');

function toSourcesAndDestination(args, defaultOptions) {
  var _toSources = toSources(args, defaultOptions),
      sources = _toSources.sources,
      options = _toSources.options,
      callback = _toSources.callback;

  var destination = sources.pop();
  return {
    sources: sources,
    destination: destination,
    options: options,
    callback: callback
  };
}

module.exports = toSourcesAndDestination;